import React from 'react'
import styled from 'styled-components'

interface ISpinnerProps {
  showSpinner: boolean
  size: 'lg' | 'md' | 'sm' | 'xs'
  id?: string
  ariaLabel?: string
  light?: boolean
}

const getSpinnerSize = (size: ISpinnerProps['size']) => {
  switch (size) {
    case 'lg':
      return '4.5rem'
    case 'md':
      return '2.5rem'
    case 'sm':
      return '2rem'
    case 'xs':
      return '1.5rem'
    default:
      return '3rem'
  }
}

const StyledSpinner = styled.div<ISpinnerProps>`
  opacity: ${(props) => (props.showSpinner ? 1 : 0)};
  .cb-spinner.hub-custom-spinner {
    width: ${(props) => getSpinnerSize(props.size)};
    height: ${(props) => getSpinnerSize(props.size)};
  }
  transition: opacity 0.3s ease-in-out;
`

export const Spinner: React.FC<ISpinnerProps> = ({
  showSpinner,
  size,
  id = 'landscape-spinner',
  ariaLabel = 'Loading...',
  light = false,
}) => {
  return (
    <>
      {showSpinner && (
        <StyledSpinner
          className="display-flex justify-content-center"
          role="status"
          aria-labelledby={id}
          size={size}
          showSpinner={showSpinner}
        >
          <div
            className={`cb-spinner hub-custom-spinner ${light && 'cb-spinner-light'}`}
            id={id}
            role="img"
            aria-label={ariaLabel}
          >
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </StyledSpinner>
      )}
    </>
  )
}
